import axios from "axios";

const isIo = window.location.hostname.split(".").pop() === "io";

// Public (no-session) endpoints — /api/pub/*. Sent with the shared apiKey header; the
// server rate-limits them per IP as well, since the key ships in this bundle.
const publicAxios = axios.create({
  baseURL:
    (isIo ? process.env.REACT_APP_API_URL_IO : process.env.REACT_APP_API_URL) ||
    "http://localhost:5000/api",
  headers: { apiKey: process.env.REACT_APP_PUB_API_KEY },
});

export default publicAxios;
